var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac_edit",
    transform: "translate(-70 -1140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5297",
    "data-name": "Rectangle 5297",
    transform: "translate(70 1140)",
    fill: "#6d809f",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ac_edit-2",
    "data-name": "ac_edit",
    d: "M10.4,6A4.4,4.4,0,0,0,6,10.4V25.96a4.4,4.4,0,0,0,4.4,4.4h6.815c.124-.486.307-1.138.556-2.011L10.4,28.328A2.371,2.371,0,0,1,8.03,25.96V13.423h20.3v3.8a4.179,4.179,0,0,1,.951-.308,3.655,3.655,0,0,1,.8-.073c.092,0,.182.007.274.013V10.4A4.4,4.4,0,0,0,25.96,6Zm0,2.03H25.96A2.371,2.371,0,0,1,28.328,10.4v1H8.03C8.03,9.092,9.092,8.03,10.4,8.03ZM30.019,18.179a3.182,3.182,0,0,0-.562.052,3.137,3.137,0,0,0-1.652.9c-8.225,8.225-8.4,8.526-8.5,8.853l-1.063,3.708a1.028,1.028,0,0,0-.066.4,1.936,1.936,0,0,0,.967.97,1.03,1.03,0,0,0,.4-.066l3.708-1.063c.17-.049.332-.121,1.831-1.55.95-.905,3.073-3,7.022-6.947a3.137,3.137,0,0,0,.9-1.652,3.246,3.246,0,0,0,.05-.562,3.048,3.048,0,0,0-3.045-3.046Z",
    transform: "translate(66.692 1136.691)",
    fill: "#1e3772"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcEdit);
export default __webpack_public_path__ + "static/media/ac_edit.299a61ccd586800362110d3467d25cae.svg";
export { ForwardRef as ReactComponent };